import { Component } from '@angular/core';
import { ErrorPageComponent } from '../error-page/error-page.component';

@Component({
    selector: 'app-error-403',
    standalone: true,
    imports: [ErrorPageComponent],
    templateUrl: './error-403.component.html'
})
export class Error403Component {

}
